import { createTheme } from '@mui/material/styles';

const PRIMARY_YELLOW = '#FFD400';
const BORDER_GREY = '#D8DADC';

export const figmaTheme = createTheme({
  palette: {
    primary: {
      main: PRIMARY_YELLOW,
      contrastText: '#000000',
    },
    secondary: {
      main: '#828282',
    },
    error: {
      main: '#E64646',
    },
    background: {
      default: '#F5F5F5',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#000000',
      secondary: 'rgba(0, 0, 0, 0.7)',
    },
    divider: BORDER_GREY,
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    h1: {
      fontFamily: 'Poppins, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Poppins, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      fontWeight: 700,
    },
    button: {
      fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F5F5F5',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
        containedPrimary: {
          backgroundColor: PRIMARY_YELLOW,
          color: '#000000',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#FFFFFF',
        },
        notchedOutline: {
          borderColor: BORDER_GREY,
        },
        input: {
          paddingTop: 18,
          paddingBottom: 18,
          paddingLeft: 16,
          paddingRight: 16,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#000000',
          fontWeight: 400,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: BORDER_GREY,
        },
      },
    },
  },
});
